'use client';

/**
 * Fires a view_item event for Google Analytics. *Note: Do not ever push PII into the data layer!!*
 *
 * @example
 * const { fireEvent } = useViewItemListEvent();
 * fireEvent(items);
 */

import { useCallback } from 'react';
import { sendGTMEvent } from '@next/third-parties/google';
import { VIEW_ITEM } from 'constants/analyticsConstants';
import { CartResponse } from 'services/cart/types';
import { getViewItemEventData } from 'utils/gaEventAnalytics';
import { ProductsPriceData } from 'app/[lang]/[esite]/(core)/(search-display)/_components/analytics-listener/types';
import { PriceAvailabilityResponse } from 'services/priceAvailability/types';

export type ListData = {
  item_list_id: string;
  item_list_name: string;
};

export type ViewItemType = {
  cartId?: string;
  cartItemsData?: CartResponse;
  products: Product[] & ProductsPriceData[];
  locationId?: string;
  type?: string;
  isProductsData?: boolean;
  itemListData?: ListData;
  priceData?: PriceAvailabilityResponse;
  productStatus?: string;
};

export const useViewItem = () => {
  const buildEvent = useCallback(
    ({
      cartId,
      cartItemsData,
      products,
      locationId,
      isProductsData = false,
      itemListData,
      priceData,
      productStatus
    }: ViewItemType) => {
      return getViewItemEventData({
        cartId,
        cartItemsData,
        products,
        locationId,
        type: VIEW_ITEM,
        isProductsData,
        itemListData,
        priceData,
        productStatus
      });
    },
    []
  );
  const fireEvent = useCallback(
    (data: ViewItemType) => {
      sendGTMEvent({ ecommerce: null });
      sendGTMEvent(buildEvent(data));
    },
    [buildEvent]
  );

  return { fireEvent };
};
